unit DonationsForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, BaseList, Data.DB, WEBLib.ExtCtrls, WEBLib.Actions, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, WEBLib.DBCtrls, Vcl.Controls, WEBLib.Lists, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.WebCtrls, smx.webcore.types, XData.Web.Client, Paginator.Plugins;

type
  TDonationsList = class(TBaseListForm)
    CaptionSpan: THTMLSpan;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetExternalId: TStringField;
    MainDatasetSponsored: TBooleanField;
    MainDatasetTransactionDate: TDateTimeField;
    MainDatasetImportId: TIntegerField;
    MainDatasetClaimId: TIntegerField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetDonorId: TIntegerField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetClaimDate: TDateTimeField;
    MainDatasetTaxYear: TIntegerField;
    MainDatasetClaimRef: TStringField;
    MainDatasetDonorPostCode: TStringField;
    MainDatasetDonorName: TStringField;
    MainDatasetErrorText: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetSourceType: TStringField;
    DownloadListButton: TButton;
    WebTimer1: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure SearchButtonClick(Sender: TObject);
    procedure DownloadListButtonClick(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
  private
    const
      SORTING_CLASS = 'sorting';
      SORTING_ASC_CLASS = 'sorting_asc';
      SORTING_DESC_CLASS = 'sorting_desc';
    var
      FShowStatus: String;
      FCurrentPage: Integer;
      FTotalCount: Integer;
      FPaginatorPlugin: TPaginatorPlugin;
      FLoading: Boolean;
      FSortField: string;
      FSortDescending: Boolean;
    procedure SetShowCaption(const Value: String);
    procedure ApplyPageResult(const ARows: TJSArray; ATotalCount: Integer);
    procedure PaginatorPageClick(APaginatorPlugin: TPaginatorPlugin);
    procedure DonationsPageSizeChange(Sender: TObject);
    function GetPageSize: Integer;
    procedure ConfigureSortHeader(ACol: Integer);
    procedure ApplySort(const AFieldName: string; ADescending: Boolean);
    [async]
    procedure LoadServiceData(AIncludeTotal: Boolean); async;
    { Private declarations }
  protected
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
    procedure LoadData; override;

    function InitSortCol: Integer;override;
    function InitSortDirection: TSortDirection;override;
    function CreateGridInFormCreate: boolean;override;
    procedure SearchData(const Value: string);override;
    [async]
    procedure GenerateUnclaimedDonationsCSVFile; async;

  public
    { Public declarations }
    property ShowStatus: String read FShowStatus write FShowStatus;
    property ShowCaption: String write SetShowCaption;

  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  MainDataModule,
  Reports.Donation.Utils;


procedure TDonationsList.WebFormCreate(Sender: TObject);
begin
  inherited;
  FCurrentPage := 1;
  FTotalCount := 0;
  FLoading := False;
  FSortField := 'TransactionDate';
  FSortDescending := True;
  FPaginatorPlugin := TPaginatorPlugin.Create(lcPaginator, @PaginatorPageClick);
  cbPageSize.OnChange := @DonationsPageSizeChange;
  DataTable.OnGetCellChildren := DataTableGetCellChildren;
  AddButton.Visible := False;
  AddButton.Enabled := False;
end;

{ TUnclaimedDonations }

procedure TDonationsList.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
begin
  inherited;

end;

procedure TDonationsList.LoadData;
begin
  FCurrentPage := 1;
  LoadServiceData(True);
end;

procedure TDonationsList.PrepareForm;
begin
  FIdField := 'Id';
end;

procedure TDonationsList.SearchButtonClick(Sender: TObject);
begin
  SearchData(edSearch.Text);
end;

procedure TDonationsList.SetShowCaption(const Value: String);
begin
 CaptionSpan.HTML.Text := Value;
end;

procedure TDonationsList.WebFormShow(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TDonationsList.SearchData(const Value: string);
begin
  FCurrentPage := 1;
  LoadServiceData(True);
end;

function TDonationsList.GetPageSize: Integer;
begin
  Result := StrToIntDef(cbPageSize.Text, 10);
  if Result < 1 then
    Result := 10;
end;

procedure TDonationsList.DonationsPageSizeChange(Sender: TObject);
begin
  FCurrentPage := 1;
  LoadServiceData(False);
end;

procedure TDonationsList.PaginatorPageClick(APaginatorPlugin: TPaginatorPlugin);
begin
  FCurrentPage := APaginatorPlugin.ActivePage;
  LoadServiceData(False);
end;

procedure TDonationsList.ApplySort(const AFieldName: string; ADescending: Boolean);
begin
  FSortField := AFieldName;
  FSortDescending := ADescending;
  FCurrentPage := 1;
  LoadServiceData(False);
end;

procedure TDonationsList.ConfigureSortHeader(ACol: Integer);
var
  Element: TJSHTMLElement;
  FieldName: string;

  function HeaderClick(Event: TJSMouseEvent): Boolean;
  begin
    if SameText(FSortField, FieldName) then
      ApplySort(FieldName, not FSortDescending)
    else
      ApplySort(FieldName, False);
    Result := True;
  end;
begin
  if (ACol < 0) or (ACol >= DataTable.Columns.Count) then
    Exit;
  FieldName := DataTable.Columns[ACol].DataField;
  if FieldName = '' then
    Exit;
  if DataTable.CellElements[ACol, 0] = nil then
    Exit;

  Element := DataTable.CellElements[ACol, 0];
  Element.onclick := @HeaderClick;
  Element.style.setProperty('cursor', 'pointer');

  Element.classList.remove(SORTING_CLASS);
  Element.classList.remove(SORTING_ASC_CLASS);
  Element.classList.remove(SORTING_DESC_CLASS);

  if SameText(FSortField, FieldName) then
  begin
    if FSortDescending then
      Element.classList.add(SORTING_DESC_CLASS)
    else
      Element.classList.add(SORTING_ASC_CLASS);
  end
  else
    Element.classList.add(SORTING_CLASS);
end;

procedure TDonationsList.DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
begin
  if ARow = 0 then
  begin
    ConfigureSortHeader(ACol);
    Exit;
  end;

  inherited;
end;

procedure TDonationsList.ApplyPageResult(const ARows: TJSArray; ATotalCount: Integer);
var
  LPageSize: Integer;
  LPageCount: Integer;
  LFirstRecord: Integer;
  LLastRecord: Integer;
  LRows: TJSArray;
  LCol: Integer;
begin
  FTotalCount := ATotalCount;
  LPageSize := GetPageSize;
  if ARows <> nil then
    LRows := ARows
  else
    LRows := TJSArray.new;

  if FTotalCount <= 0 then
  begin
    FCurrentPage := 1;
    lcPaginator.Items.Clear;
    lbPaginationInfo.Caption := 'No records';
  end
  else
  begin
    LPageCount := (FTotalCount + LPageSize - 1) div LPageSize;
    if FCurrentPage > LPageCount then
      FCurrentPage := LPageCount;
    if FCurrentPage < 1 then
      FCurrentPage := 1;

    FPaginatorPlugin.Init(FCurrentPage, LPageCount);
    LFirstRecord := ((FCurrentPage - 1) * LPageSize) + 1;
    LLastRecord := LFirstRecord + LRows.Length - 1;
    if LLastRecord > FTotalCount then
      LLastRecord := FTotalCount;
    lbPaginationInfo.Caption := Format('%d to %d of %d', [LFirstRecord, LLastRecord, FTotalCount]);
  end;

  MainDataset.Active := False;
  MainDataset.SetJsonData(LRows);
  MainDataset.Active := True;
  DataTable.Invalidate;

  for LCol := 0 to DataTable.Columns.Count - 1 do
    ConfigureSortHeader(LCol);
end;

procedure TDonationsList.LoadServiceData(AIncludeTotal: Boolean);
var
  LResponse: TXDataClientResponse;
  LPage: TJSObject;
  LRows: TJSArray;
  LTotalCount: Integer;
  LSkip: Integer;
  LPageSize: Integer;
  LAttempt: Integer;
  LPageCount: Integer;
  LIncludeTotal: Boolean;
begin
  if FLoading then
    Exit;

  FLoading := True;
  UnLockControls(False);
  try
    try
      LPageSize := GetPageSize;
      if FCurrentPage < 1 then
        FCurrentPage := 1;

      // Recount when asked, or when we do not yet have a usable total.
      LIncludeTotal := AIncludeTotal or (FTotalCount <= 0);

      LRows := TJSArray.new;
      LTotalCount := FTotalCount;

      for LAttempt := 1 to 2 do
      begin
        LSkip := (FCurrentPage - 1) * LPageSize;

        LResponse := await(TXDataClientResponse,
          MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetUnclaimedDonationsList',
            [LSkip, LPageSize, edSearch.Text.Trim, FSortField, FSortDescending, LIncludeTotal]));

        LPage := LResponse.ResultAsObject;
        LRows := nil;
        LTotalCount := -1;

        if (LPage <> nil) and (LPage['value'] <> nil) and (LPage['Items'] = nil) then
          LPage := TJSObject(LPage['value']);

        if LPage <> nil then
        begin
          if LPage['Items'] <> nil then
            LRows := TJSArray(LPage['Items']);
          if LPage['TotalCount'] <> nil then
            LTotalCount := JS.toInteger(LPage['TotalCount'])
          else if LPage['totalCount'] <> nil then
            LTotalCount := JS.toInteger(LPage['totalCount']);
        end;

        if LRows = nil then
          LRows := TJSArray.new;

        // Server returns -1 when count was skipped; keep the cached total.
        if LTotalCount < 0 then
          LTotalCount := FTotalCount;

        if (LRows.Length = 0) and (LTotalCount > 0) and (LSkip >= LTotalCount) then
        begin
          LPageCount := (LTotalCount + LPageSize - 1) div LPageSize;
          if LPageCount < 1 then
            LPageCount := 1;
          FCurrentPage := LPageCount;
          Continue;
        end;

        Break;
      end;

      ApplyPageResult(LRows, LTotalCount);
    except
      on E: Exception do
      begin
        // Clear stale rows so a failed search does not look like a match.
        FTotalCount := 0;
        FCurrentPage := 1;
        ApplyPageResult(TJSArray.new, 0);
        ShowMessage('Search failed. Please try again or use a shorter search term.' + sLineBreak + E.Message);
      end;
    end;
  finally
    FLoading := False;
    UnLockControls(True);
    AddButton.Visible := False;
    AddButton.Enabled := False;
  end;
end;

function TDonationsList.InitSortCol: Integer;
begin
  Result := 1;
end;

function TDonationsList.InitSortDirection: TSortDirection;
begin
  Result := TSortDirection.sdDesc;
end;

function TDonationsList.CreateGridInFormCreate: boolean;
begin
  result := false;
end;

procedure TDonationsList.DownloadListButtonClick(Sender: TObject);
begin
  GenerateUnclaimedDonationsCSVFile;
end;


procedure TDonationsList.GenerateUnclaimedDonationsCSVFile;
begin
  Await(TDonationReportUtils.DonationReport('DN.CLAIM_STATUS', 'Unclaimed', 0, 0, '', '', TReportOutput.roCSV));
end;

procedure TDonationsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CaptionSpan := THTMLSpan.Create('CaptionSpan');
  DownloadListButton := TButton.Create('UnclaimedDonations');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetSponsored := TBooleanField.Create(Self);
  MainDatasetTransactionDate := TDateTimeField.Create(Self);
  MainDatasetImportId := TIntegerField.Create(Self);
  MainDatasetClaimId := TIntegerField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetDonorId := TIntegerField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetClaimDate := TDateTimeField.Create(Self);
  MainDatasetTaxYear := TIntegerField.Create(Self);
  MainDatasetClaimRef := TStringField.Create(Self);
  MainDatasetDonorPostCode := TStringField.Create(Self);
  MainDatasetDonorName := TStringField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  WebTimer1 := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  CaptionSpan.BeforeLoadDFMValues;
  DownloadListButton.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetSponsored.BeforeLoadDFMValues;
  MainDatasetTransactionDate.BeforeLoadDFMValues;
  MainDatasetImportId.BeforeLoadDFMValues;
  MainDatasetClaimId.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetDonorId.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetClaimDate.BeforeLoadDFMValues;
  MainDatasetTaxYear.BeforeLoadDFMValues;
  MainDatasetClaimRef.BeforeLoadDFMValues;
  MainDatasetDonorPostCode.BeforeLoadDFMValues;
  MainDatasetDonorName.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Top := 110;
    SetEvent(DataTable, Self, 'OnGetCellChildren', 'DataTableGetCellChildren');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorName';
      Title := 'Donor';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorPostCode';
      Title := 'Post Code';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ClaimStatus';
      Title := 'ClaimStatus';
    end;
    CaptionSpan.SetParentComponent(Self);
    CaptionSpan.Name := 'CaptionSpan';
    CaptionSpan.Left := 632;
    CaptionSpan.Top := 48;
    CaptionSpan.Width := 100;
    CaptionSpan.Height := 40;
    CaptionSpan.HeightStyle := ssAuto;
    CaptionSpan.WidthStyle := ssAuto;
    CaptionSpan.ChildOrder := 10;
    CaptionSpan.ElementPosition := epIgnore;
    CaptionSpan.ElementFont := efCSS;
    CaptionSpan.Role := '';
    DownloadListButton.SetParentComponent(Self);
    DownloadListButton.Name := 'DownloadListButton';
    DownloadListButton.Left := 207;
    DownloadListButton.Top := 439;
    DownloadListButton.Width := 297;
    DownloadListButton.Height := 25;
    DownloadListButton.Caption := 'Download Unnclaimed Donations';
    DownloadListButton.ChildOrder := 9;
    DownloadListButton.ElementClassName := 'btn btn-secondary';
    DownloadListButton.ElementPosition := epIgnore;
    DownloadListButton.HeightStyle := ssAuto;
    DownloadListButton.HeightPercent := 100.000000000000000000;
    DownloadListButton.WidthStyle := ssAuto;
    DownloadListButton.WidthPercent := 100.000000000000000000;
    SetEvent(DownloadListButton, Self, 'OnClick', 'DownloadListButtonClick');
    MainDataset.EntitySetName := 'Donation';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 255;
    MainDatasetSponsored.SetParentComponent(MainDataset);
    MainDatasetSponsored.Name := 'MainDatasetSponsored';
    MainDatasetSponsored.FieldName := 'Sponsored';
    MainDatasetTransactionDate.SetParentComponent(MainDataset);
    MainDatasetTransactionDate.Name := 'MainDatasetTransactionDate';
    MainDatasetTransactionDate.FieldName := 'TransactionDate';
    MainDatasetTransactionDate.DisplayFormat := 'DD/MM/YYYY';
    MainDatasetImportId.SetParentComponent(MainDataset);
    MainDatasetImportId.Name := 'MainDatasetImportId';
    MainDatasetImportId.FieldName := 'ImportId';
    MainDatasetClaimId.SetParentComponent(MainDataset);
    MainDatasetClaimId.Name := 'MainDatasetClaimId';
    MainDatasetClaimId.FieldName := 'ClaimId';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.FieldName := 'Amount';
    MainDatasetDonorId.SetParentComponent(MainDataset);
    MainDatasetDonorId.Name := 'MainDatasetDonorId';
    MainDatasetDonorId.FieldName := 'DonorId';
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 9;
    MainDatasetClaimDate.SetParentComponent(MainDataset);
    MainDatasetClaimDate.Name := 'MainDatasetClaimDate';
    MainDatasetClaimDate.FieldName := 'ClaimDate';
    MainDatasetTaxYear.SetParentComponent(MainDataset);
    MainDatasetTaxYear.Name := 'MainDatasetTaxYear';
    MainDatasetTaxYear.FieldName := 'TaxYear';
    MainDatasetClaimRef.SetParentComponent(MainDataset);
    MainDatasetClaimRef.Name := 'MainDatasetClaimRef';
    MainDatasetClaimRef.FieldName := 'ClaimRef';
    MainDatasetClaimRef.Size := 32;
    MainDatasetDonorPostCode.SetParentComponent(MainDataset);
    MainDatasetDonorPostCode.Name := 'MainDatasetDonorPostCode';
    MainDatasetDonorPostCode.FieldName := 'DonorPostCode';
    MainDatasetDonorPostCode.Size := 15;
    MainDatasetDonorName.SetParentComponent(MainDataset);
    MainDatasetDonorName.Name := 'MainDatasetDonorName';
    MainDatasetDonorName.FieldName := 'DonorName';
    MainDatasetDonorName.Size := 50;
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Left := 48;
    WebTimer1.Top := 432;
  finally
    DataTable.AfterLoadDFMValues;
    CaptionSpan.AfterLoadDFMValues;
    DownloadListButton.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetSponsored.AfterLoadDFMValues;
    MainDatasetTransactionDate.AfterLoadDFMValues;
    MainDatasetImportId.AfterLoadDFMValues;
    MainDatasetClaimId.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetDonorId.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetClaimDate.AfterLoadDFMValues;
    MainDatasetTaxYear.AfterLoadDFMValues;
    MainDatasetClaimRef.AfterLoadDFMValues;
    MainDatasetDonorPostCode.AfterLoadDFMValues;
    MainDatasetDonorName.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
  end;
end;

end.
